<template>
    <div class="ump-dashboard-wsc">
        <van-row>
        <div class="application-list animation-order-1"><p class="application-title"><span>销售渠道</span><span
                class="application-title-desc">多渠道售卖你的商品</span></p>
            <ul class="application-list-content clearfix">
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img src="static/images/icon/icon-weixin.png">
                    </div>
                    <div class="application-name">微信公众号</div>
                    <div class="application-desc">公众号玩转微信生态</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img src="static/images/icon/icon-xiaochengxu.png">
                    </div>
                    <div class="application-name">微信小程序</div>
                    <div class="application-desc">一键生成微信小程序</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-weibo.png">
                    </div>
                    <div class="application-name">微博</div>
                    <div class="application-desc">连接微博帐号，打通微博渠道</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-zhifubao.png">
                    </div>
                    <div class="application-name">支付宝生活号</div>
                    <div class="application-desc">在支付宝中经营你的店铺</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-app.png">
                    </div>
                    <div class="application-name">App大师</div>
                    <div class="application-desc">一键生成App</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-app-store.png">
                    </div>
                    <div class="application-name">App开店</div>
                    <div class="application-desc">让自有App快速获得电商能力</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-gonghuoshang.png" >
                    </div>
                    <div class="application-name">供货商</div>
                    <div class="application-desc">铺货到分销市场，让自媒体大号分销</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-fenxiao.png" >
                    </div>
                    <div class="application-name">分销员
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">客户带客户，销量涨涨涨</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-shurufa.png" >
                    </div>
                    <div class="application-name">有赞搜狗输入法</div>
                    <div class="application-desc">电商专用，把店铺开到聊天窗口里</div>
                </a></li>
                <li class="application-item" ><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-quntuangou.png">
                    </div>
                    <div class="application-name">群团购
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">社群变渠道，轻松赚大钱</div>
                </a></li>
            </ul>
        </div>
        <div class="application-list animation-order-2"><p class="application-title"><span>营销玩法</span><span
                class="application-title-desc">吸粉、老客带新客，提高下单转化率</span></p>
            <ul class="application-list-content clearfix">
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-youhuijuan.png" >
                    </div>
                    <div class="application-name">优惠券
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                        <span class="application-tips"></span></div>
                    <div class="application-desc">向客户发放店铺优惠券</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-youhuima.png" >
                    </div>
                    <div class="application-name">优惠码
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">向客户发放店铺优惠码</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-tuanfanxian.png" >
                    </div>
                    <div class="application-name">团购返现
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">根据最终销量对买家进行返现</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/icon-orderfanxian.png" >
                    </div>
                    <div class="application-name">订单返现
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">客户下单后获得返现奖励</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/35aadcb09089b8b1b6e45bf43a933a69.png"
                             >
                    </div>
                    <div class="application-name">限时折扣
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                        <span class="application-tips"></span></div>
                    <div class="application-desc">设置商品限时打折促销</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/9c2f470596df3d59a64888eef3d7169a.png"
                             >
                    </div>
                    <div class="application-name">秒杀
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">快速抢购引导顾客更多消费</div>
                </a></li>
                <li class="application-item"><a href="//www.youzan.com/v2/ump/paidpromotion"
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/c0e9de6487d4f2cf63b8c64c31a8b146.png"
                             >
                    </div>
                    <div class="application-name">支付有礼</div>
                    <div class="application-desc">客户付款后引导参与营销互动</div>
                </a></li>
                <li class="application-item" ><a href="//www.youzan.com/v2/ump/present"
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/fd5ba6b19e0724bee3c7b4e8c1b8629a.png"
                             >
                    </div>
                    <div class="application-name">赠品
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">设置赠品，回馈客户</div>
                </a></li>
                <li class="application-item"><a href="//www.youzan.com/v2/ump/reward"
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/fd8388a3bbe09c1282628ef9eb767c68.png"
                             >
                    </div>
                    <div class="application-name">满减/送
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                        <span class="application-tips"></span></div>
                    <div class="application-desc">购满一定金额或件数享受优惠</div>
                </a></li>
                <li class="application-item"><a href="//www.youzan.com/v2/ump/packagebuy"
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/aacca58ab07bb57a1d492142d739bdea.png">
                    </div>
                    <div class="application-name">优惠套餐
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">创建商品套餐让客户购买</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/01e22ad6a534dd083742698adca39ad0.png">
                    </div>
                    <div class="application-name">打包一口价
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                        <span class="application-tips"></span></div>
                    <div class="application-desc">给我N元，这里的商品随便挑</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/3ebf966975334f9b06278e9d175d7c4a.png">
                    </div>
                    <div class="application-name">多人拼团
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">引导客户邀请朋友一起拼团购买</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/6f1407151a5a9467cd6cf4a21350dff8.png">
                    </div>
                    <div class="application-name">周期购
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="will-support-weapp"></span></div>
                    </div>
                    <div class="application-desc">一次性卖掉一年的商品</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/ed4690d346171f78a11c9261d4371386.png">
                    </div>
                    <div class="application-name">降价拍</div>
                    <div class="application-desc">价格随时间下降的促销活动</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/09287bf2547cc33b2e935a6a38fef727.png">
                    </div>
                    <div class="application-name">找人代付</div>
                    <div class="application-desc">让客户可以邀请朋友代付款</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/dff8776e552d3408abd800e4a04944ed.png">
                    </div>
                    <div class="application-name">我要送礼</div>
                    <div class="application-desc">让客户可以购买商品送给朋友</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/ba80899b32b73f33af525b8b94d8eac9.png">
                    </div>
                    <div class="application-name">我要送礼（社群版）
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">让客户可以购买商品送给朋友</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/6fde66ce312b402f6bb140826fbd67f2.png">
                    </div>
                    <div class="application-name">刮刮卡</div>
                    <div class="application-desc">通过刮开卡片进行抽奖的玩法</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/b1f911cb3e882b1396706e6bba4fcea4.png">
                    </div>
                    <div class="application-name">疯狂猜</div>
                    <div class="application-desc">回答问题，按答题情况给奖励</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/2f7466594dac012476c1b13f4f65a101.png">
                    </div>
                    <div class="application-name">生肖翻翻看</div>
                    <div class="application-desc">通过翻卡片进行抽奖的玩法</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/2af7e724a67c2b61db519d66e66b0c14.png">
                    </div>
                    <div class="application-name">分场次抽奖</div>
                    <div class="application-desc">多个场次，⽴即抽奖</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/f1be031b020e754b0d30877bad201fb6.png">
                    </div>
                    <div class="application-name">幸运砸金蛋</div>
                    <div class="application-desc">好运砸出来</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/400855584ccaf4896c8e387739d5f7d3.png">
                    </div>
                    <div class="application-name">幸运大抽奖</div>
                    <div class="application-desc">常见的转盘式抽奖玩法</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/8aaf304ab274a05f86b37a49004026ee.png">
                    </div>
                    <div class="application-name">摇一摇</div>
                    <div class="application-desc">让客户摇一摇，进行抽奖</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/8fd1d16d2d12a208bd1614d96ff9f69a.png">
                    </div>
                    <div class="application-name">水果机</div>
                    <div class="application-desc">水果方格转盘抽奖</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/49091d9dafeb404ded6eec270e7f2ab3.png">
                    </div>
                    <div class="application-name">好友瓜分券
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">邀请好友瓜分优惠券，带来更多流量</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/87db2e7488d0479bfb09902ce928d239.png"
                             ></div>
                    <div class="application-name">砍价0元购
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">引导用户邀请好友砍价后低价购买</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/9653281e8fb1195c27d687c785f7fa8c.png"
                             ></div>
                    <div class="application-name">收藏有礼（小程序）
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">全面抢占微信流量入口</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/9dc8db87e969fdb5220a82b92cba11f1.png">
                    </div>
                    <div class="application-name">抽奖拼团
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="will-support-weapp"></span></div>
                    </div>
                    <div class="application-desc">拼团成功即可获得抽奖机会</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img src="https://img.yzcdn.cn/wsc/paidcontent/referral/aicon@2x.png">
                    </div>
                    <div class="application-name">推荐有奖
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">课程类商品老带新，提升转化</div>
                </a></li>
                <li class="application-item free-of-charge"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img src="https://img.yzcdn.cn/wsc/money-dilation/Group@2x.jpg">
                    </div>
                    <div class="application-name">定金膨胀</div>
                    <div class="application-desc">预售定金翻N倍，大促预热利器</div>
                </a></li>
            </ul>
        </div>
        <div class="application-list animation-order-3"><p class="application-title"><span>客群维护</span><span
                class="application-title-desc">让老客户更多重复购买，提高客单贡献</span></p>
            <ul class="application-list-content clearfix">
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/e790e67d4fb0d272b1f78eef02f0587f.png">
                    </div>
                    <div class="application-name">签到</div>
                    <div class="application-desc">每日签到领取积分或奖励</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/ace4ce49d7e71fc20f13483c6ea2362a.png">
                    </div>
                    <div class="application-name">会员卡
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">设置并给客户发放会员卡</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/1ce51aacb68802468d90ea0c15cce689.png">
                    </div>
                    <div class="application-name">会员储值</div>
                    <div class="application-desc">开通会员储值功能</div>
                </a></li>
                <li class="application-item latest"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/d63b9a1aa8e0b3a0ac77635866e4cb28.png">
                    </div>
                    <div class="application-name">礼品卡
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">获新客、促活跃、提复购</div>
                </a></li>
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/f5662bd03e6768ae8f4df3535c0596fd.png">
                    </div>
                    <div class="application-name">积分商城
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                        <span class="application-tips"></span></div>
                    <div class="application-desc">让客户用积分兑换礼品</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/d3dec67706a710977b797488947b85af.png">
                    </div>
                    <div class="application-name">发券宝
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">优惠券定向群发神器</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/948af6c23b6b5c28003731e27739efd8.png">
                    </div>
                    <div class="application-name">互动粉丝营销</div>
                    <div class="application-desc">高效激活粉丝，提高10%销售额</div>
                </a></li>
            </ul>
        </div>
        <div class="application-list animation-order-4"><p class="application-title"><span>经营分析</span><span
                class="application-title-desc">掌握客户动向，实时分析经营数据，高效优化运营效果</span></p>
            <ul class="application-list-content clearfix">
                <li class="application-item"><a href=""
                                                                        class="application-entry">
                    <div class="application-logo"><img
                            src="https://img.yzcdn.cn/public_files/2018/07/18/1d06fc47363248478f2ea30ed601eb65.png"
                             >
                    </div>
                    <div class="application-name">热力图
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">掌握页面点击热点</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/3d72ceea0a409be888d2ffbb051c4c3c.png">
                    </div>
                    <div class="application-name">推广分析
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">精准跟踪推广的投入产出数据</div>
                </a></li>
                <li class="application-item latest"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/df56a24f64214bbfd7173a42fe646466.png">
                    </div>
                    <div class="application-name">单品分析
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">剖析商品表现，探寻增长点</div>
                </a></li>
            </ul>
        </div>
        <div class="application-list animation-order-5"><p class="application-title"><span>配套工具</span><span
                class="application-title-desc">扫码、核销、多网点、调研等</span></p>
            <ul class="application-list-content clearfix">
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/2c8bf22e375d0aba3fd1144cb7ab8f25.png" >
                    </div>
                    <div class="application-name">扫码收款
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">生成直接收款页面和收款码</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/bcea73fcdecdfb182dfc04f9ad8c9415.png">
                    </div>
                    <div class="application-name">验证工具</div>
                    <div class="application-desc">核销优惠券/码、电子卡券等</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/964c51bc2754946445f92aa13d06885a.png"
                             >
                    </div>
                    <div class="application-name">消息推送
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">向客户发送短信/微信消息通知</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/1f8e6844f9f540254fe4bd1dcd823dbf.png"
                             >
                    </div>
                    <div class="application-name">多网点
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">根据客户位置推荐附近门店</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/e0a96ae512ca43021dcdbc0ddf8349b5.png"
                             >
                    </div>
                    <div class="application-name">对话搜索</div>
                    <div class="application-desc">在公众号里通过关键字搜商品</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/b57b6250c6c96095e2db3c52ef61ad15.png"
                             >
                    </div>
                    <div class="application-name">投票调查</div>
                    <div class="application-desc">创建在线投票调查页面</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/66e48c200753536dd9a277106f2fc53b.png"
                             >
                    </div>
                    <div class="application-name">模板市场
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">丰富的页面模版供你挑选</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/273dc78fed266637bfc8904c34f6870f.png"
                             >
                    </div>
                    <div class="application-name">退货运费补贴</div>
                    <div class="application-desc">买家退货可享受运费补贴</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="https://img.yzcdn.cn/public_files/2018/04/16/f7849c420e7c4ef9052cdb7f83e92f13.jpg"
                             >
                    </div>
                    <div class="application-name">电子发票</div>
                    <div class="application-desc">买家自助开票，方便高效</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img src="https://img.yzcdn.cn/v3/img/electron_way_bill.png"
                                                        >
                    </div>
                    <div class="application-name">电子面单</div>
                    <div class="application-desc">快速高效打印快递电子面单</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img src="https://img.yzcdn.cn/v3/img/logistics_service.png"
                                                        >
                    </div>
                    <div class="application-name">物流服务</div>
                    <div class="application-desc">快速开通快递服务商及运单管理</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/65cf404a5138edb9fb42e25247505e2f.png"
                             >
                    </div>
                    <div class="application-name">包邮工具
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">包邮，运费减免</div>
                </a></li>
                <li class="application-item"><a
                        href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/0cb83d3adb8bce2e05d07b544510cc81.png"
                             ></div>
                    <div class="application-name">客服销售业绩报表</div>
                    <div class="application-desc">提供客服绩效的数据支撑</div>
                </a></li>
            </ul>
        </div>
        <div class="application-list animation-order-6"><p class="application-title"><span>垂直行业</span><span
                class="application-title-desc">知识付费、酒店等垂直行业应用</span></p>
            <ul class="application-list-content clearfix">
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/58aee5622ed7ab4eb2fdd93f15036403.png" >
                    </div>
                    <div class="application-name">知识付费
                        <div class="zent-popover-wrapper zent-pop-wrapper" style="display: inline-block;"><span
                                class="support-weapp"></span></div>
                    </div>
                    <div class="application-desc">图文、音频、视频等内容变现触手可及</div>
                </a></li>
                <li class="application-item"><a href="" class="application-entry">
                    <div class="application-logo"><img
                            src="static/images/icon/15b8c8b38992304da9fd09eb2a84fd1d.png" >
                    </div>
                    <div class="application-name">酒店预订</div>
                    <div class="application-desc">便捷管理每日房价和库存</div>
                </a></li>
            </ul>
        </div>
        </van-row>
        <van-tabbar v-model="active">
            <van-tabbar-item icon="shop" :url="'#/mobile'">店铺</van-tabbar-item>
            <van-tabbar-item :url="'#/mobile/market/index'">
                <span>应用</span>
                <img slot="icon"
                     slot-scope="props"
                     :src="props.active ? icon.active : icon.normal"
                >
            </van-tabbar-item>
            <van-tabbar-item icon="contact" :url="memberUrl">管理中心</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import {TabbarItem,Tabbar,Row} from 'vant'
    export default {
        name: "index",
        components:{
            [Tabbar.name]:Tabbar,
            [TabbarItem.name]:TabbarItem,
            [Row.name]:Row
        },
        data(){
            return {
                active:1,
                icon: {
                    normal: 'static/images/icon-applications-normal.png',
                    active: 'static/images/icon-applications-active.png'
                },
                memberUrl:this.loginDomain+'/jz/#/',
            }
        }
    }
</script>

<style scoped>
    .ump-dashboard-wsc{
        margin:0 0 50px 0;



    }
    .application-list .application-title {
        color: #333;
        font-size: 18px;
        margin-bottom: 15px;
    }
    .application-title span{
        text-align: center;
        display: block;
    }
    .application-list .application-title-desc {
        color: #999;
        font-size: 12px;
        margin-left: 5px;
    }
    .application-item {
        background: #f8f8f8;
        margin: 15px auto;
        width: 100%;
    }
    .application-item .application-entry {
        box-sizing: border-box;
        display: block;
        padding: 10px;
        width: 100%;
        zoom: 1;
    }
    .application-item .application-entry .application-logo {
        border-radius: 4px;
        float: left;
        height: 40px;
        width: 40px;
    }
    .application-item .application-entry .application-logo>img {
        height: 40px;
        vertical-align: bottom;
        width: 40px;
    }
    .application-item .application-entry .application-name {
        -ms-flex-align: center;
        align-items: center;
        color: #333;
        display: -ms-flexbox;
        display: flex;
        font-size: 14px;
        font-weight: 700;
        height: 24px;
        line-height: 24px;
        margin-left: 50px;
        vertical-align: bottom;
    }
    .application-item .application-entry .application-desc {
        color: #999;
        font-size: 12px;
        height: 16px;
        line-height: 16px;
        margin-left: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
        white-space: nowrap;
    }
</style>
